import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import SecureStore from "react-secure-storage";

import images from '../libs/images';
import consts from '../libs/consts';
import routes from '../libs/routes';

import { useUser, useMenu, usePopup, useHeader, useLang } from "../zustand/store.js";
import { numFormat, useWindowSize } from '../utils/utils';

import { LangText } from "../zustand/dict.js";


export default function LeftNavLang(props) {

    const {
        isOpen,
    } = props;

    const navigate = useNavigate();
    const location = useLocation();

    const { country, setLang } = useLang();
    const { langPop, toggleLangPop } = usePopup();

    const clickFunc = (v) => {

        SecureStore.setItem('country', v);
        setLang({ key: 'country', value: v });

        toggleLangPop();
    }

    const anim = {
        open: { x: 0, display: "block" },
        close: { x: "100%", display: "none" }
    }


    return (
        <>
            <motion.div
                style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                    background: "white",
                    zIndex: 101
                }}
                initial={anim.close}
                animate={isOpen ? anim.open : anim.close}
                exit={{ x: "100%" }}
                transition={{ duration: 0.2 }}
                onClick={() => {

                }}
            >
                <div
                    className='language_list'
                    style={{
                        padding: 16,
                        display: "flex",
                        flexDirection: "column",
                    }}>

                    <p className='body2 color-g300'>
                        <LangText id={'text_set_language'} />
                    </p>
                    <p style={{ width: "100%" }} className={country === 'ko' ? 'active' : ''} onClick={() => clickFunc('ko')}>한국어</p>
                    <p style={{ width: "100%" }} className={country === 'en' ? 'active' : ''} onClick={() => clickFunc('en')}>English</p>
                </div>
            </motion.div>
        </>
    )
}